module.exports = __webpack_public_path__ + "media/images/official/badge_202403-cd3be54c688fc5cae95ac9cc953c3ce4.svg";